import { render, staticRenderFns } from "./RouteReportDataTable.vue?vue&type=template&id=887bae90&"
import script from "./RouteReportDataTable.vue?vue&type=script&lang=js&"
export * from "./RouteReportDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports